import text from "./text.json";
import errorMessages from "./errorMessages.json";

export const englishConstants = {
  ...text,
  ...errorMessages,
};
